const envConfigPlugin = {
    install(Vue, config) {

    Vue.prototype.$envConfig = Object.freeze(config);
    },
  
  };
  
  export default envConfigPlugin;